<template>
  <div class="identitySelection">
    <job-header-simple header_title="认证方式选择"></job-header-simple>

    <van-cell-group>
      <van-cell
        v-if="flag_bankcard4"
        title="银行卡四要素认证"
        label="(需银行预留手机号)"
        :icon="icon_card4"
        is-link
        @click="handleCardIndentify('bankcard4')"
      />
      <van-cell
        v-if="flag_face"
        title="人脸识别"
        label="(拍摄脸部，快速验证身份)"
        :icon="icon_face"
        is-link
        @click="handleIndentify"
      />
      <van-cell
        v-if="flag_card"
        title="银行卡三要素认证"
        label=""
        :icon="icon_card3"
        is-link
        @click="handleCardIndentify('card')"
      />
      <van-cell
        v-if="flag_telecom3"
        title="手机号认证"
        label=""
        :icon="icon_phone"
        is-link
        @click="handleCardIndentify('telecom3')"
      />
    </van-cell-group>
  </div>
</template>

<script>
import { Cell, CellGroup, Toast } from 'vant'
import jobHeaderSimple from '@/components/header/header.vue'
import api from '@/api/list'
import { browserUA } from '@/utils/browserUA'
export default {
  components: {
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    jobHeaderSimple,
  },
  data() {
    return {
      icon_card4: require('@/assets/icon_identity_card4.png'),
      icon_card3: require('@/assets/icon_identity_card3.png'),
      icon_phone: require('@/assets/icon_identity_phone.png'),
      icon_face: require('@/assets/icon_identity_face.png'),
      flag_bankcard4: false,
      flag_card: false,
      flag_telecom3: false,
      flag_face: false,
    }
  },
  mounted() {
    this.showList()
  },
  methods: {
    //显示哪些
    showList() {
      let cerficationTypes = this.$route.query.cerficationTypes.split(',')
      if (cerficationTypes.length > 0) {
        cerficationTypes.map((item) => {
          this['flag_' + item] = true
        })
      }
    },
    handleCardIndentify(type) {
      this.$router.push({
        path: '/identity',
        query: {
          bankCard: this.$route.query.bankCard,
          bankName: this.$route.query.bankName,
          contractId: this.$route.query.contractId,
          bankMobile: this.$route.query.bankMobile,
          type: type,
        },
      })
    },
    handleIndentify() {
            this.$router.push({
              path: '/identity',
              query: {
                bankCard: this.$route.query.bankCard,
                bankName:this.$route.query.bankName,
                bankMobile: this.$route.query.bankMobile,
                contractId: this.$route.query.contractId,
                front: this.$route.query.front,
                back:this.$route.query.back,
                bankCardId: this.$route.query.bankCardId,
                type: 'face',
              },
            })
    //     let param ={
    //               bankCardId: this.$route.query.bankCardId,
    //               contractId: this.$route.query.contractId
    //     }
    //   api.individualFace(param).then((res) => {
    //     if (res.status == '200') {
    //       // debugger
    //       let json = JSON.parse(res.data.data)
    //       if (json == null) {
    //         Toast.fail(res.data.message)
    //       } else {
    //         console.log(JSON.stringify({ url: json.url }))
    //         browserUA().then((browserType) => {
    //           if (browserType == 'androidAPP') {
    //             window.VpShopJs.bodyCheck(JSON.stringify({ url: json.url }))
    //           } else {
    //             location.href = json.url
    //           }
    //         })
    //       }
    //     } else {
    //       Toast.fail('发起认证失败')
    //     }
    //   })
    },
  },
}
</script>

<style lang="less" scoped>
.identitySelection {
  /deep/ .van-cell-group {
    background: transparent;
    padding: 10px;
    .van-cell {
      margin-bottom: 10px;
      border-radius: 10px;
      padding: 12px 24px;

      &:not(:last-child)::after {
        border-bottom: none;
      }
    }

    .van-cell__title {
      margin-top: 4px;
      margin-left: 10px;
    }

    .van-cell__right-icon {
      margin-top: 3px;
    }

    .van-icon__image {
      width: 30px;
      height: 30px;
    }

    .van-cell__label {
      display: inline-block;
      vertical-align: middle;
      margin-top: -2px;
      font-size: 14px;
    }
  }
}
</style>
